
import { useToast } from "@/hooks/use-toast";
import { getSupabaseClient } from "./supabaseClients";

export const useConnectionTest = () => {
  const { toast } = useToast();

  const testSupabaseConnection = async () => {
    console.log('🔍 Testing Supabase connection...');
    try {
      // Check if we have SMS auth instead of Supabase auth
      const staffAuth = localStorage.getItem('staff_sms_auth');
      const hasSmsAuth = staffAuth && JSON.parse(staffAuth).authenticated;
      
      console.log('Authentication context:', {
        hasSmsAuth
      });

      const client = getSupabaseClient();
      
      // Test connection with a simple query that doesn't require special permissions
      const { data, error, count } = await client
        .from('orders')
        .select('*', { count: 'exact' })
        .limit(1);
      
      console.log('Supabase connection test result:', { 
        success: !error,
        error: error?.message,
        hasData: !!data,
        dataLength: data?.length || 0,
        totalCount: count,
        rawData: data
      });

      if (error) {
        console.error('❌ Supabase connection error:', error);
        
        // Check if it's an authentication/permission error
        if (error.message.includes('Invalid API key') || error.message.includes('authentication')) {
          toast({
            title: "Authentication Issue",
            description: "Unable to access database. Please check your authentication status.",
            variant: "destructive"
          });
        } else {
          toast({
            title: "Database Connection Error",
            description: error.message,
            variant: "destructive"
          });
        }
      } else {
        console.log('✅ Supabase connection successful');
        if (count === 0) {
          console.log('⚠️ Database is empty - no orders found');
          toast({
            title: "Connection Successful",
            description: "Connected to database successfully, but no orders found.",
          });
        } else {
          console.log(`📊 Found ${count} total orders in database`);
          toast({
            title: "Connection Successful",
            description: `Connected successfully - found ${count} orders.`,
          });
        }
      }
    } catch (error) {
      console.error('❌ Failed to test Supabase connection:', error);
      toast({
        title: "Connection Test Failed",
        description: "Unable to connect to database - check console for details",
        variant: "destructive"
      });
    }
  };

  return { testSupabaseConnection };
};
